var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUgcanLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsev: "http://www.w3.org/2001/xml-events",
    width: "2.02417in",
    height: "0.520556in",
    viewBox: "0 0 145.74 37.48",
    xmlSpace: "preserve",
    colorInterpolationFilters: "sRGB",
    className: "st6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st1 {fill:#19ba92;stroke:#ffffff;stroke-width:0.24}\n\t\t.st2 {fill:#19ba92;stroke:#ffffff;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.5}\n\t\t.st3 {fill:#ffffff;stroke:#19ba92;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.24}\n\t\t.st4 {fill:#19ba92;stroke:#19ba92;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.24}\n\t\t.st5 {fill:#ffffff;font-family:Montserrat;font-size:1.16666em}\n\t\t.st6 {fill:none;fill-rule:evenodd;font-size:12px;overflow:visible;stroke-linecap:square;stroke-miterlimit:3}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Page-1"), /*#__PURE__*/React.createElement("g", {
    id: "group188-1",
    transform: "translate(0.24,-0.24)"
  }, /*#__PURE__*/React.createElement("title", null, "Sheet.188"), /*#__PURE__*/React.createElement("g", {
    id: "shape179-2"
  }, /*#__PURE__*/React.createElement("title", null, "Block Arrow"), /*#__PURE__*/React.createElement("path", {
    d: "M2 37.48 L132.41 37.48 A2 2 -180 0 0 134.09 36.57 L144.79 20.07 A2 2 -180 0 0 144.79 17.89 L134.09 1.39  A2 2 -180 0 0 132.41 0.48 L2 0.48 A2 2 -180 0 0 -0 2.48 L0 35.48 A2 2 -180 0 0 2 37.48 Z",
    className: "st1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape186-4",
    transform: "translate(1.93915,-1.51326)"
  }, /*#__PURE__*/React.createElement("title", null, "Block Arrow.186"), /*#__PURE__*/React.createElement("path", {
    d: "M0 37.48 L130.56 37.48 L141.56 20.53 L130.56 3.58 L0 3.58 L0 37.48 Z",
    className: "st2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape181-6",
    transform: "translate(3.5,-5.12333)"
  }, /*#__PURE__*/React.createElement("title", null, "Block Arrow.181"), /*#__PURE__*/React.createElement("path", {
    d: "M0 37.48 L125.25 37.48 L134.25 23.98 L125.25 10.48 L0 10.48 L0 37.48 Z",
    className: "st3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shape182-8",
    transform: "translate(3.5,-5.25321)"
  }, /*#__PURE__*/React.createElement("title", null, "Block Arrow.182"), /*#__PURE__*/React.createElement("desc", null, "College Avenue"), /*#__PURE__*/React.createElement("path", {
    d: "M0 37.48 L116.5 37.48 L125 23.98 L116.5 10.48 L0 10.48 L0 37.48 Z",
    className: "st4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 8.7,
    y: 28.18,
    className: "st5"
  }, "College Avenue"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUgcanLogo);
export default __webpack_public_path__ + "static/media/ugcan-logo.8232e0c6d34177b700755d3b694b1131.svg";
export { ForwardRef as ReactComponent };